import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { AppDispatch } from "../store";
import { transitionRecordActions as slice } from "../slices/transitionRecord";
import { getErrorMessage } from "../../utils/errorUtils";
import { TransitionRecordEvaluationRequestDto } from "../../shared/dtos/transitionRecord/TransitionRecordEvaluationRequestDto";
import { TransitionRecordEvaluationResponseDto } from "../../shared/dtos/transitionRecord/TransitionRecordEvaluationResponseDto";
import { TransitionRecordBulkRequestDto } from "../../shared/dtos/transitionRecord/TransitionRecordBulkRequestDto";
import { TransitionRecordResponseDto } from "../../shared/dtos/transitionRecord/TransitionRecordResponseDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";
import { TransitionStatus } from "../../shared/enums/TransitionStatus";
import { PaginationQueryDto } from "../../shared/dtos/common/PaginationQueryDto";
import { PaginatedResponse } from "../../shared/dtos/common/PaginatedResponse";

export interface TransitionHistoryQueryParams extends PaginationQueryDto {
  branchId?: string;
  studentId?: string;
  fromAcademicYearId?: string;
  toAcademicYearId?: string;
  fromClassroomId?: string;
  status?: TransitionStatus;
  startDate?: string;
  endDate?: string;
}

export const evaluateTransitions =
  (values: TransitionRecordEvaluationRequestDto) =>
  async (dispatch: AppDispatch) => {
    dispatch(slice.setLoadingEvaluation());
    try {
      const { data } = await axiosInstance.post<
        ApiResponseDto<TransitionRecordEvaluationResponseDto[]>
      >("/transition-records/evaluate", values, {
        headers: { requiresAuth: true },
      });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(slice.setEvaluations(data.data));
        toast.success("Evaluation complete. Please review the suggestions.");
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(slice.setErrorEvaluation(message));
    }
  };

export const executeBulkTransitions =
  (values: TransitionRecordBulkRequestDto) => async (dispatch: AppDispatch) => {
    dispatch(slice.setLoadingTransitionExecute());
    try {
      const { data } = await axiosInstance.post<ApiResponseDto<void>>(
        "/transition-records/execute",
        values,
        { headers: { requiresAuth: true } },
      );

      if (data.status === ApiResponseStatus.SUCCESS) {
        toast.success("Transitions executed successfully!");
        dispatch(slice.executeTransitionsSuccess());
        dispatch(
          slice.setServerResponseStatus({
            operation: "execute",
            status: data.statusCode || 200,
          }),
        );
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(slice.setErrorExecutingTransition(message));
    }
  };

export const getTransitionRecords =
  (params?: TransitionHistoryQueryParams) => async (dispatch: AppDispatch) => {
    dispatch(slice.setLoadingTransitionRecords());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<PaginatedResponse<TransitionRecordResponseDto>>
      >("/transition-records", {
        headers: { requiresAuth: true },
        params,
      });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(slice.setTransitionRecords(data.data.content));
        dispatch(slice.setPagination(data.data.pagination));
      }
    } catch (error) {
      dispatch(slice.setErrorLoadingTransitionRecords(getErrorMessage(error)));
    }
  };

export const resetTransitionRecordStatus = () => (dispatch: AppDispatch) => {
  dispatch(slice.resetTransitionRecordServerStatus());
};
